import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function SupportContact({ title = 'Need a hand?', text = 'Our team is here to help with your questions.' }) {
  const location = useLocation();
  return <><aside className="support-contact"><div><h2>{title}</h2><p>{text}</p></div><Link className="photo-primary" to="/contact">Contact Our Team</Link></aside><nav className="support-navigation" aria-label="Policies and help">{[['Terms of Service','/terms-of-service'],['Privacy Policy','/privacy-policy'],['FAQ','/questions']].map(([label,path]) => <Link key={path} to={path} aria-current={location.pathname === path ? 'page' : undefined}>{label}</Link>)}</nav></>;
}
